import React from 'react';

import classnames from 'classnames';
import PropTypes from 'prop-types';
import Table from 'react-bootstrap/Table';

import './MLTable.scss';

const MLTable = ({ children, className, ...props }) => {
    const classes = classnames(className, 'ml-table');

    return (
        <Table borderless striped size="sm" className={classes} {...props}>
            { children }
        </Table>
    );
};

MLTable.propTypes = {
    className: PropTypes.string,
    children: PropTypes.node,
};

export default MLTable;
